var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31.3601C7.53057 31.3601 0.640015 24.4696 0.640015 16.0001C0.640015 7.5307 7.53057 0.640137 16 0.640137C24.4695 0.640137 31.36 7.5307 31.36 16.0001C31.36 24.4696 24.4695 31.3601 16 31.3601ZM16 2.56014C8.58913 2.56014 2.56001 8.58926 2.56001 16.0001C2.56001 23.411 8.58913 29.4401 16 29.4401C23.4109 29.4401 29.44 23.411 29.44 16.0001C29.44 8.58926 23.4109 2.56014 16 2.56014ZM24.5389 19.3096C24.7747 18.8376 24.584 18.267 24.1143 18.0277C23.6435 17.7899 23.0675 17.9771 22.8247 18.4449C22.7543 18.58 21.049 21.7601 16 21.7601C10.9632 21.7601 9.25409 18.5957 9.17601 18.4462C8.93825 17.9745 8.36258 17.7835 7.89057 18.0216C7.41634 18.2587 7.22401 18.8353 7.46113 19.3096C7.55073 19.4881 9.71873 23.6801 16 23.6801C22.2813 23.6801 24.4493 19.4881 24.5389 19.3096ZM20.8 14.0801C19.7411 14.0801 18.88 13.219 18.88 12.1601C18.88 11.1013 19.7411 10.2401 20.8 10.2401C21.8589 10.2401 22.72 11.1013 22.72 12.1601C22.72 13.219 21.8589 14.0801 20.8 14.0801ZM11.2 14.0801C10.1411 14.0801 9.28001 13.219 9.28001 12.1601C9.28001 11.1013 10.1411 10.2401 11.2 10.2401C12.2589 10.2401 13.12 11.1013 13.12 12.1601C13.12 13.219 12.2589 14.0801 11.2 14.0801Z",
    fill: "orange"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentiment);
export default __webpack_public_path__ + "static/media/sentiment.a8c4c0a801ce1e029d334608a99e229b.svg";
export { ForwardRef as ReactComponent };